import React from 'react'
import Project_overview from '../pages/Project_overview';
import r1 from '../images/r1.png';
import r2 from '../images/r2.png';
import '../css/BlockDiagram.css';
const Sketch = () => {
  return (
    
    <div className='sketch-div' >
        <Project_overview />
        <div className="sketch-diagram">
            <img src={r1} alt="" />
            <img src={r2} alt="" />
        </div>
    </div>
  )
}

export default Sketch;